import { render, staticRenderFns } from "./IngredientConfiguration.vue?vue&type=template&id=20e16424&scoped=true"
import script from "./IngredientConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./IngredientConfiguration.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./IngredientConfiguration.vue?vue&type=style&index=0&id=20e16424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e16424",
  null
  
)

export default component.exports